import { apiGateway } from "@contexts";
import { GetBankTransactionStatusResponse } from "@interfaces";
import { useQuery } from "@tanstack/react-query";
import { millisecondsInSecond } from "date-fns";
import { isAxiosError } from "axios";

const BANK_TRANSFER_REJECTED_MESSAGE = "Bank transfer rejected";

const isBankTransferRejectedError = (error: unknown): boolean =>
  isAxiosError(error) &&
  error.response?.data &&
  typeof error.response.data === "object" &&
  "message" in error.response.data &&
  (error.response.data as { message?: string }).message ===
    BANK_TRANSFER_REJECTED_MESSAGE;

export const useVerifyBankTransferStatus = () =>
  useQuery({
    queryKey: ["transactionStatus"],
    queryFn: () =>
      apiGateway<GetBankTransactionStatusResponse>({
        url: "/enrolment/bank-transfer-challenge/verify",
        method: "GET",
      }),
    staleTime: 2 * millisecondsInSecond,
    refetchInterval: (query) =>
      isBankTransferRejectedError(query.state.error)
        ? false
        : 3 * millisecondsInSecond,
  });
